var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 1.66699H3.40854C3.73657 1.66699 3.90058 1.66699 4.03257 1.72731C4.14888 1.78047 4.24745 1.86596 4.31653 1.97359C4.39491 2.09572 4.4181 2.25808 4.46449 2.58281L5.09556 7.00033M5.09556 7.00033L6.49809 17.3089C6.67607 18.617 6.76506 19.2711 7.07779 19.7635C7.35336 20.1973 7.74844 20.5423 8.21547 20.7568C8.74548 21.0003 9.40558 21.0003 10.7258 21.0003H22.1363C23.393 21.0003 24.0214 21.0003 24.5349 20.7742C24.9877 20.5748 25.3761 20.2534 25.6567 19.846C25.9749 19.3838 26.0925 18.7665 26.3276 17.532L28.0925 8.26658C28.1752 7.83207 28.2166 7.61481 28.1566 7.44499C28.104 7.29602 28.0002 7.17057 27.8637 7.09102C27.7081 7.00033 27.487 7.00033 27.0446 7.00033H5.09556ZM12.3337 27.0003C12.3337 27.7367 11.7367 28.3337 11.0003 28.3337C10.2639 28.3337 9.66699 27.7367 9.66699 27.0003C9.66699 26.2639 10.2639 25.667 11.0003 25.667C11.7367 25.667 12.3337 26.2639 12.3337 27.0003ZM23.0003 27.0003C23.0003 27.7367 22.4034 28.3337 21.667 28.3337C20.9306 28.3337 20.3337 27.7367 20.3337 27.0003C20.3337 26.2639 20.9306 25.667 21.667 25.667C22.4034 25.667 23.0003 26.2639 23.0003 27.0003Z",
    stroke: "#4E5368",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIconBlack);
export default __webpack_public_path__ + "static/media/cart-icon--black.1474ddf01d84966b0d8829cd52c33f47.svg";
export { ForwardRef as ReactComponent };